import { usePermissions } from "@api/permissions";
import DataGrid from "@components/DataGrid/DataGrid";
import i18n from "@i18n/i18n";
import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import useResizeObserver from "use-resize-observer";

interface PermissionRowModel {
  id: string;
  permissionId?: string;
  name?: string;
  description?: string;
}

const PermissionsGrid = observer(() => {
  const containerRef = useRef(null);
  const { height } = useResizeObserver({ ref: containerRef });
  const [rows, setRows] = useState<PermissionRowModel[]>([]);
  const getPermissions = usePermissions();

  useEffect(() => {
    if (getPermissions.data?.permissions) {
      const permissionRows: PermissionRowModel[] = getPermissions.data.permissions.map((permission) => ({
        id: permission.permissionId || "",
        permissionId: permission.permissionId,
        name: permission.name,
        description: permission.description,
      }));
      setRows(permissionRows);
    }
  }, [getPermissions.data]);

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: i18n.t("permissions-tab.grid.column.name"),
      flex: 2,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: i18n.t("permissions-tab.grid.column.description"),
      flex: 3,
      minWidth: 300,
    },
  ];

  return (
    <Box
      ref={containerRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        loading={getPermissions.isFetching}
        getRowId={(row) => row.id}
        sx={{
          height: height ? `${height}px` : "100%",
          width: "100%",
        }}
      />
    </Box>
  );
});

export default PermissionsGrid;
